// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 00:14:38

export default {
  "id": "sword-play-ninja-slice-runner",
  "slug": "sword-play-ninja-slice-runner",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/f37e6802a81944d7bbe172e496b79eb9-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/f37e6802a81944d7bbe172e496b79eb9/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Sword Play! Ninja Slice Runner",
      "description": "Become a legendary kunai master in this thrilling combination of dynamic gameplay and classic ninja action. Play offline and enjoy the freedom to dive into the adventure whenever you want. Slice through foes, overcome obstacles, and set out on an epic ninja quest without boundaries.\n\nWill you seize the blade and claim your place as the ultimate ninja warrior?",
      "instructions": "Navigating the game is easy and intuitive. Use your mouse on a desktop or simply tap with your finger on mobile devices.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "1player",
        "ninja",
        "ragdoll",
        "runner",
        "sword"
      ]
    },
    "zh-CN": {
      "title": "剑术大作战！忍者斩跑者",
      "description": "成为传奇苦无大师，在这款充满动态玩法和经典忍者动作的游戏中尽情冒险。离线游玩，随时享受探索的乐趣。斩敌于无形，克服障碍，踏上无界限的忍者史诗之旅。\n\n你将拿起武器，成为终极忍者战士吗？",
      "instructions": "游戏操作简单直观。在台式机上使用鼠标，或在移动设备上轻轻触摸屏幕即可。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "1玩家",
        "忍者",
        "布娃娃",
        "跑酷",
        "剑"
      ]
    },
    "zh-TW": {
      "title": "劍術大作戰！忍者斬跑者",
      "description": "成為這個刺激結合動態遊戲玩法和經典忍者動作的傳奇苦無大師。離線遊玩，享受隨時隨地投入冒險的自在。橫切敵人，克服障礙，踏上無界限的經典忍者冒險之旅。\n\n你將會握練劍，奪取作為無敵忍者戰士的位子嗎？",
      "instructions": "遊戲導航簡單直觀。在桌面上使用滑鼠，或在行動裝置上直接用手指點擊即可。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "1玩家",
        "忍者",
        "布娃娃",
        "跑酷",
        "劍"
      ]
    },
    "zh-HK": {
      "title": "劍術大戰！忍者斬跑者",
      "description": "成為一個傳奇般的苦無大師，在這個動態遊戲玩法和經典忍者動作之間享受刺激的體驗。離線遊玩，隨時隨地享受冒險的自由。橫切敵人，克服障礙，展開一場無邊界的忍者冒險之旅。\n\n你會握緊刀刃，奪取作為無敵忍者戰士的位置嗎？",
      "instructions": "遊戲操作簡單直觀。在桌上型電腦上使用滑鼠，或在行動裝置上輕輕觸碰即可。",
      "genres": [
        "隨機"
      ],
      "tags": [
        "1人玩家",
        "忍者",
        "布娃娃",
        "跑酷",
        "劍"
      ]
    },
    "ja": {
      "title": "剣遊戯！忍び切りランナー",
      "description": "このダイナミックなゲームプレイと古典的な忍術アクションが楽しめるスリリングなコンビネーションで、伝説のクナイの達人になるんだ。オフラインでいつでも冒険に飛び込みられる自由を楽しむんだ。敵を切り裂き、障害を乗り越え、境界線のない壮大な忍術の冒険に出発するんだ。\n\n剣を握り、究極の忍者戦士としての自分の地位を確立するのか？",
      "instructions": "ゲームの操作は簡単で直感的です。デスクトップではマウスを使用し、モバイルデバイスでは指でタップしてください。",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "1プレイヤー",
        "忍者",
        "ラグドール",
        "ランナー",
        "剣"
      ]
    },
    "ko": {
      "title": "검기 게임! 닌자 슬라이스 러너",
      "description": "이 흥미진진한 동적 게임플레이와 전통 닌자 액션의 결합에서 전설적인 키나이 마스터가 되어보세요. 오프라인으로 플레이하고 언제든지 모험에 뛰어들 수 있는 자유를 즐겨보세요. 적을 베리고 장애물을 극복하고, 경계 없는 닌자 퀘스트에 떠나보세요.\n\n칼을 잡고 최종 닌자 전사로서의 자리를 차지하시겠습니까?",
      "instructions": "게임을 탐색하는 것은 쉽고 직관적입니다. 데스크톱에서 마우스를 사용하거나 모바일 기기에서 손가락으로 탭하십시오.",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "1플레이어",
        "닌자",
        "랭도ール",
        "러너",
        "검"
      ]
    },
    "fr": {
      "title": "Jeu d'épées ! Sprinteur Slice Ninja",
      "description": "Devenez un maître légendaire du kunai dans cette aventure captivante qui allie gameplay dynamique et action ninja classique. Jouez en ligne et profitez de la liberté de plonger dans l'aventure à tout moment. Coupez vos ennemis, surmontez les obstacles et entrez dans une quête ninja épique sans limites.\n\nPréparez-vous à saisir l'épée et à revendiquer votre place en tant que guerrier ninja ultime ?",
      "instructions": "La navigation dans le jeu est facile et intuitive. Utilisez votre souris sur un ordinateur de bureau ou tout simplement tapez avec votre doigt sur les appareils mobiles.",
      "genres": [
        "Occasionnel"
      ],
      "tags": [
        "1 joueur",
        "ninja",
        "ragdoll",
        "coureur",
        "épée"
      ]
    }
  }
};
